const statusRowStyle = (color) => {
  return {
    borderLeftColor: color,
    borderLeftWidth: 5,
    borderLeftStyle: 'solid'
  }
}

export default statusRowStyle
